export Listing from './Listing';



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/arrivals-departures/containers/index.js